const GPWIS_JOB_DETAILS_REPORT_HEADER = [
  "Job Id",
  "Customer Name",
  "Contract No",
  "Leg No",
  "Rake Name",
  "Origin",
  "Origin Code",
  "Destination",
  "Destination Code",
  "Job At Destination",
  "Commodity",
  "Cargo Owner Name",
  "Rr No",
  "Rr Date",
  "Rr Amount",
  "Rr Attachment",
  "Rake Arrival At Serving Station Datetime",
  "Rake Arrival At Station Datetime",
  "Rake Placement Datetime",
  "Rake Full Or Part Load",
  "Loco Detachment Datetime",
  "Rake Cleaning Datetime",
  "Rake Status",
  "Quantity Of Cargo",
  "Rr Punitive",
  "Ir Load Name",
  "Origin Load Name",
  "Eot Of Customer Loco",
  "Eot Datetime",
  "Offered To Ir",
  "Damage Wagon",
  "Job Completed For This Leg",
  "Reason For Non Completion Of Job",
  "Rake Departure Datetime From Station",
  "Rake Departure Datetime From Serving Station",
  "Gps Device Id",
  "Wagon No Attached To Gps",
  "Tat Of Leg",
  "Total Cycle Tat",
  "Record Status",
  "Createddate",
  "Createdby",
  "Updateddate",
  "Updatedby",
  "Circuit Name",
  "Freight To Be Paid By",
  "Job Status",
  "Cycle Id",
  "Job Approval Status",
  "Job Remarks",
  "Main Step Id",
  "Sub Step Id",
  "Approved By",
  "Approver Remarks",
  "Approved Date",
  "Rr Remarks",
  "Rebate Amount",
  "Sap Io Id",
  "Sap So Id",
  "Sap So Invoice Id",
  "Sap Lineitem No",
  "Serv Mat No",
  "Serv Mat Desc",
  "Target Qty Uom",
  "Target Qty",
  "Unit Price",
  "Ship To Party",
  "Customer Ref",
  "Customer Ref Date",
  "Sap Customer Id",
  "Cust Grp5",
  "Sap Rake Number",
  "Purchase Contract No",
  "Purchase Contract Lineitem No",
  "Sap Ship To Party",
  "Total Fee",
  "Chargeable Quantity",
  "Rr Attachment Dms Fileid",
  "Rr Chargeable Quantity",
  "Invoice Created Date",
  "So Created Date",
  "Vendor Code",
  "Cost Center",
  "Rr Actual Weight",
  "So Group",
  "So Number",
  "Invoice Number",
  "Invoice Generated",
  "Commodity Loaded",
  "Payment Terms",
  "Job Created User Emailid",
  "Map My India Id",
  "Loading Start Datetime",
  "Loading End Datetime",
  "No Of Wagons Loaded",
  "Forwarding Note Attachment",
  "Invoice Party",
  "Confirm Invoice",
  "Is Invoice Sent To Customer",
  "Damage To Wagon",
  "Job Complete For This Leg",
  "Reason For Non Completion",
  "Forwarding Note Attachment Dms Fileid",
  "Invoice Bill Date",
  "Other Charge Name",
  "Other Charge Value",
  "Remarks",
  "Unloading Start Datetime",
  "Unloading Completion Datetime",
  "No Of Wagons Unloaded",
  "Revenue Details",
  "Purchase Details"
]

const GPWIS_JOB_REPORT_KEYS = [
  "job_id",
  "customer_name",
  "customer_work_order_no",
  "leg_no",
  "rake_name",
  "origin",
  "origin_code",
  "destination",
  "destination_code",
  "job_at_destination",
  "commodity",
  "cargo_owner_name",
  "rr_no",
  "rr_date",
  "rr_amount",
  "rr_attachment",
  "rake_arrival_at_serving_station_datetime",
  "rake_arrival_at_station_datetime",
  "rake_placement_datetime",
  "rake_full_or_part_load",
  "loco_detachment_datetime",
  "rake_cleaning_datetime",
  "rake_status",
  "quantity_of_cargo",
  "rr_punitive",
  "ir_load_name",
  "origin_load_name",
  "eot_of_customer_loco",
  "eot_datetime",
  "offered_to_ir",
  "damage_wagon",
  "job_completed_for_this_leg",
  "reason_for_non_completion_of_job",
  "rake_departure_datetime_from_station",
  "rake_departure_datetime_from_serving_station",
  "gps_device_id",
  "wagon_no_attached_to_gps",
  "tat_of_leg",
  "total_cycle_tat",
  "record_status",
  "createddate",
  "createdby",
  "updateddate",
  "updatedby",
  "circuit_name",
  "freight_to_be_paid_by",
  "job_status",
  "cycle_id",
  "job_approval_status",
  "job_remarks",
  "main_step_id",
  "sub_step_id",
  "approved_by",
  "approver_remarks",
  "approved_date",
  "rr_remarks",
  "rebate_amount",
  "sap_io_id",
  "sap_so_id",
  "sap_so_invoice_id",
  "sap_lineitem_no",
  "serv_mat_no",
  "serv_mat_desc",
  "target_qty_uom",
  "target_qty",
  "unit_price",
  "ship_to_party",
  "customer_ref",
  "customer_ref_date",
  "sap_customer_id",
  "CUST_GRP5",
  "sap_rake_number",
  "purchase_contract_no",
  "purchase_contract_lineitem_no",
  "sap_ship_to_party",
  "total_fee",
  "chargeable_quantity",
  "rr_attachment_dms_fileid",
  "rr_chargeable_quantity",
  "invoice_created_date",
  "so_created_date",
  "vendor_code",
  "cost_center",
  "rr_actual_weight",
  "so_group",
  "so_number",
  "invoice_number",
  "invoice_generated",
  "commodity_loaded",
  "payment_terms",
  "job_created_user_emailid",
  "map_my_india_id",
  "loading_start_datetime",
  "loading_end_datetime",
  "no_of_wagons_loaded",
  "forwarding_note_attachment",
  "invoice_party",
  "confirm_invoice",
  "is_invoice_sent_to_customer",
  "damage_to_wagon",
  "job_complete_for_this_leg",
  "reason_for_non_completion",
  "forwarding_note_attachment_dms_fileid",
  "invoice_bill_date",
  "other_charge_name",
  "other_charge_value",
  "remarks",
  "unloading_start_datetime",
  "unloading_completion_datetime",
  "no_of_wagons_unloaded",
  "revenue_details",
  "purchase_details"
];

const INVOICE_REPORT_TABLE_HEADER = [
  "Financial Year",
  "Quarter",
  "Month",
  "Job Id",
  "Job Date",
  "Rake Name",
  "RR No",
  "RR Date",
  "Invoice Type",
  "Invoice No",
  "Invoice Date",
  "Invoice Value",
  "Invoice Submission Date",
  "Payment Received Date",
];

const INVOICE_REPORT_TABLE_KEYS = [
  "finyear",
  "quarter",
  "month",
  "job_id",
  "createddate",
  "rake_name",
  "rr_no",
  "rr_date",
  "service_type",
  "invoice_number",
  "invoice_bill_date",
  "invoice_value",
  "invoice_submission_date",
  "payment_received_date",
];

const exportObj = {
  GPWIS_JOB_DETAILS_REPORT_HEADER,
  GPWIS_JOB_REPORT_KEYS,
  INVOICE_REPORT_TABLE_HEADER,
  INVOICE_REPORT_TABLE_KEYS,
};

export default exportObj;



